import React from 'react';
import { Typography } from 'antd';
import { MobileOutlined, CheckOutlined } from '@ant-design/icons';

import { colorForBackgroundColor } from '../../utils/RGBColorToHex';
import { toSiteDisplay, sortSitesForPreview } from '../../utils/SiteDisplayHelper';

const { Text, Title } = Typography;

const PreviewSiteCard = ({ site }) => {
  const display = site && (site.headline || site.buttonText) ? site : toSiteDisplay(site);
  if (!display) return null;

  const {
    headline, buttonText, imageUrl, color, textColor,
    displayName, url, isApp, isShowImage, type,
  } = display;

  const panelBgColor = '#1A1A1A'; // Standard dark panel color
  const panelTextColor = '#FFF';

  const isSocial = type === 'social';
  const isStandard = !isApp && !isSocial;
  const showNameUnderIcon = isApp;
  const showLargeIcon = isApp || isSocial;

  return (
    <div className="action-site-card pb-2" style={{ backgroundColor: panelBgColor, color: panelTextColor, marginBottom: '16px', borderRadius: '12px', padding: '16px', width: '100%' }}>
      {headline && (
        <div className="site-card-title" style={{ color: panelTextColor, textAlign: 'center', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
          {headline}
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', width: '100%' }}>
        {showLargeIcon && isShowImage && imageUrl && (
          <div className="site-card-image-placeholder" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <img
              src={imageUrl}
              alt="icon"
              style={{
                width: 72,
                height: 72,
                objectFit: 'cover',
                borderRadius: isSocial ? '50%' : '16%',
                background: '#000'
              }}
            />
          </div>
        )}

        {showNameUnderIcon && displayName && (
          <div className="site-card-app-name fine-reg" style={{ color: panelTextColor, opacity: 0.8, fontSize: '12px' }}>
            {displayName}
          </div>
        )}

        <div className="text-align-center" style={{ width: '100%', marginBottom: isStandard ? '4px' : '8px', display: 'flex', justifyContent: 'center' }}>
          <a href={url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <button
              style={{
                backgroundColor: color,
                color: textColor,
                borderColor: textColor || '#FFF',
                borderWidth: '2px',
                borderStyle: 'solid',
                fontWeight: '600',
                borderRadius: '8px',
                padding: '10px 20px',
                lineHeight: '1.2',
                width: 'auto',
                cursor: 'pointer'
              }}
            >
              {buttonText}
            </button>
          </a>
        </div>

        {isStandard && displayName && (
          <div className="site-card-subtitle fine-reg px-1" style={{ width: '100%', color: 'rgba(255,255,255,0.7)', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', textAlign: 'center' }}>
              {imageUrl && <img className="site-card-thumbnail" src={imageUrl} alt="button icon" style={{ width: 22, height: 22, borderRadius: '4px', objectFit: 'cover' }} />}
              {displayName}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

const SuccessPagePreview = ({ sites, team }) => {
  const sortedSites = sortSitesForPreview(sites || []);
  const { teamName, topLogo } = team || {};
  const rgbColor = '#2cad5a';
  
  const contrastColor = colorForBackgroundColor(rgbColor);

  return (
    <div style={{ 
      position: 'sticky', 
      top: '24px', 
      width: '100%', 
      maxWidth: '320px',
      margin: '0 auto' 
    }}>
      <div style={{ 
        textAlign: 'center', 
        marginBottom: '12px', 
        color: '#8c8c8c', 
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        fontWeight: 'bold'
      }}>
        <MobileOutlined /> Thank You Page Preview
      </div>
      
      <div style={{ 
        background: '#000000', 
        borderRadius: '40px',
        border: '12px solid #1A1A1A',
        boxShadow: '0 30px 60px rgba(0,0,0,0.8)',
        overflowY: 'auto',
        minHeight: '560px',
        maxHeight: 'min(820px, 75vh)',
        aspectRatio: '9 / 19.5',
        width: '100%',
        maxWidth: '320px',
        margin: '0 auto',
        position: 'relative'
      }}>
        <div style={{ 
          background: rgbColor, 
          padding: '28px 16px 24px', 
          textAlign: 'center',
          color: contrastColor
        }}>
          <div style={{ width: 84, height: 84, borderRadius: '50%', background: '#FFFFFF', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CheckOutlined style={{ color: rgbColor, fontSize: '34px' }} />
          </div>
          <Title level={3} style={{ color: contrastColor, margin: 0, fontSize: '24px', fontWeight: '700' }}>Tip successful</Title>
          {teamName && (
            <Text style={{ color: contrastColor, opacity: 0.85, fontSize: '12px', display: 'block', marginTop: '6px' }}>
              {teamName}
            </Text>
          )}
        </div>

        <div style={{ padding: '20px 6px 40px' }}>
          {sortedSites.length > 0 ? (
            sortedSites.map((site) => (
              <PreviewSiteCard
                key={`${site.siteId || site.id || 'site'}-${site.type || 'type'}-${site.brand || 'brand'}`}
                site={site}
              />
            ))
          ) : (
            <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.2)', padding: '40px 0' }}>
              <Text style={{ color: 'inherit' }}>Activate sites to see them previewed here</Text>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessPagePreview;
